import moment from '@tableau/metrics-engine/node_modules/moment';

import { Status } from '../serverAPI/types/CustomDomainTypes';

/*returns the number of hours left for the domain to expire */
export function hoursLeftToExpire(date: Date) {
    //Time to expire in hours
    const timeToExpire = 24;

    let hoursBetweenCurrDate =  moment().diff(date, 'hours');
    return timeToExpire - hoursBetweenCurrDate;
}

export function isValidDomain(v: string) {
    if (!v) return;
    var re = /^(?!:\/\/)([a-zA-Z0-9-]+\.){1,5}[a-zA-Z0-9-][a-zA-Z0-9-]+\.[a-zA-Z]{2,64}?$/gi;
    return re.test(v);
}

export function isCnameVerified(v: string) {
    return v === Status.cnameVerificationSuccess ||  v === Status.sslCertUploaded || v === Status.customDomainProvisioned;
}